import { Badge } from '@/components/ui/badge'
import { LeadStatus, ProjectStatus } from '@/types/api'

interface StatusBadgeProps {
  status: LeadStatus | ProjectStatus
  className?: string
}

// Covers both LeadStatus and ProjectStatus — ProjectStatus values are a subset
// of LeadStatus values (same strings), so all statuses resolve here.
const statusLabels: Record<string, string> = {
  [LeadStatus.NEW]: 'New',
  [LeadStatus.CONTACTED]: 'Contacted',
  [LeadStatus.ESTIMATE_SCHEDULED]: 'Estimate Scheduled',
  [LeadStatus.ESTIMATE_SENT]: 'Estimate Sent',
  [LeadStatus.WON]: 'Won',
  [LeadStatus.LOST]: 'Lost',
  [LeadStatus.QUALIFIED]: 'Qualified',
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge variant={status} className={className}>
      {statusLabels[status] || status}
    </Badge>
  )
}
